import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {invoiceNameSchema} from '@dms/shared';

export const getFormSchema = (
  isMechanicRequired: boolean,
  quantitySchema: z.ZodType<number>,
  isMechanicEditingDisabled = false
) =>
  z
    .object({
      sNo: z.string().nullish(),
      catalogNumber: z.string().nullish(),
      manufacturerId: z.string().nullish(),
      name: invoiceNameSchema,
      warehouseId: z.string().nullish(),
      storageLocation: z.string().nullish(),
      defaultSupplierDiscountGroupId: z.string().nullish(),
      priceType: z.string().nullish(),
      quantity: quantitySchema,
      sellingPricePerUnit: z.number(),
      vatType: z.string(),
      mechanic: z
        .string()
        .optional()
        .superRefine((val, ctx) => {
          if (!val && isMechanicRequired && !isMechanicEditingDisabled) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: i18n.t('errors.field_is_required'),
            });
          }
        }),
      discountRate: z.number().min(0).max(100).optional(),
      isUnitPriceWithVat: z.boolean(),
      vatFreeCode: z.string().nullish(),
      isCustomPrice: z.boolean(),
      isCustomDiscount: z.boolean(),
      discountType: z.string(),
      isDoNotApplyDiscount: z.boolean(),
      neededAt: z.date().nullish(),
      workItemGroupId: z.string().optional(),
      oneTimeSale: z.boolean(),
    })
    .superRefine((data, ctx) => {
      if (
        data.discountType === 'manual-discount' &&
        data.isCustomDiscount === true &&
        isNil(data.discountRate)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['discountRate'],
          message: i18n.t('errors.field_is_required'),
        });
      }
    });

export type EditMaterialItemFormType = z.infer<ReturnType<typeof getFormSchema>>;
